module.exports = __webpack_public_path__ + "img/five2Red.23434572.jpg";